import React from "react";
import { FiDelete } from 'react-icons/fi'
import { MAX_ATTEMPTS } from "./HelpersFunctions";
import TokenGlyph from "./TokenGlyph";

const Keyboard = ({buttonClick, answerDictionaryState, attemptDict, gameStatus}) => {

    let characters = [['w','è', 'e', 'é', 'r', 't', 'y','ú', 'u', 'ù', 'i', 'ò', 'o', 'ó', 'p'], ['à', 'a', 'á', 's', 'ṣ', 'd', 'f', 'g', 'h', 'j', 'k', 'l'], ['enter', 'ẹ̀', 'ẹ', 'ẹ́', 'b', 'm', 'n', 'ì', 'í', 'ọ̀', 'ọ', 'ọ́', '<']]

    const storedGameStatus = localStorage.getItem("gameStatus")
    const resolvedGameStatus = gameStatus || storedGameStatus
    const gameOver = resolvedGameStatus === "WIN" || resolvedGameStatus === "LOSE"

    // Build character status dynamically from all attempts
    let characterStatus = {}

    // Loop through all rows
    for (let rowKey = 1; rowKey <= MAX_ATTEMPTS; rowKey++) {
        if (answerDictionaryState[rowKey] === null) {
            continue // Skip rows that haven't been submitted
        }

        let rowAttempt = attemptDict[rowKey]
        let rowColors = answerDictionaryState[rowKey]

        // For each letter in this row
        for (let i = 0; i < rowAttempt.length; i++) {
            let letter = rowAttempt[i].toLowerCase()
            let status = rowColors[i] // 'correct', 'present', or 'absent'

            // Priority: correct > present > absent
            // Don't downgrade a letter's status
            if (!characterStatus[letter]) {
                characterStatus[letter] = status
            } else if (characterStatus[letter] === 'absent' && status !== 'absent') {
                characterStatus[letter] = status
            } else if (characterStatus[letter] === 'present' && status === 'correct') {
                characterStatus[letter] = status
            }
        }
    }

    return(
            <div className="keyboard">
                {characters.map((arr, index) =>
                <div key={index}  className="keyboard-row">
                    {arr.map((element, idx) =>
                        <button
                            key={idx}
                            className={`element ${characterStatus[element] || ''} ${element === 'enter' ? 'enter' : ''}`}
                            onClick={()=> buttonClick(element)}
                            disabled={gameOver}
                            >
                            {element === '<' ?  <FiDelete />: <TokenGlyph token={element} uppercase />}
                        </button>
                        )}
                </div>)}
            </div>
    )
}

export default Keyboard;
